import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { PessoaSearch } from 'app/services/grl/pessoa.search';
import { ConcessaoSearch } from 'app/services/mob/concessao.search';
import { filter, mergeMap, tap, map } from 'rxjs/operators';
import { ConcessaoService } from 'app/services/mob/concessao.service';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { PessoaJuridicaService } from './../../../../../../services/grl/pessoa-juridica.service';
import { PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, ControlContainer, FormControl } from '@angular/forms';
import { EMPTY, from, Observable } from 'rxjs';

@Component({
  selector: 'autocomplete-vistoria-concessionario-escolar',
  templateUrl: './autocomplete-vistoria-concessionario-escolar.component.html',
  styleUrls: ['./autocomplete-vistoria-concessionario-escolar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteVistoriaConcessionarioEscolarComponent implements OnInit {

  formGroup: FormGroup;
  concessionarios: PessoaJuridica[];
  @ViewChild("cdConcessionario", { static: false}) cdConcessionario: ElementRef;
  private _cdPessoa: number;

  constructor(
    private _controlContainer: ControlContainer,
    private _pessoaJuridicaService: PessoaJuridicaService,
    private _pessoaService: PessoaService,
    private _concessaoService: ConcessaoService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('concessionario', new FormControl());
    this.formGroup.get('concessionario').valueChanges.pipe(
      filter(keyword => this._validarTexo(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(concessionarios => this._finalizarBusca(concessionarios))
    ).subscribe();
  }

  ngAfterViewInit() {
    this.formGroup.get('cdPessoa').valueChanges.pipe(
      mergeMap(cdConcessionario => this._carregar(cdConcessionario)),
      map(cdConcessionario => this.pessoaSelecionada(cdConcessionario)),
    ).subscribe();
  }

  pessoaSelecionada(pessoaJuridica: PessoaJuridica) {
    if(!pessoaJuridica) return;

    this.cdConcessionario.nativeElement.value = pessoaJuridica.pessoa.nmPessoa;
    this._cdPessoa = pessoaJuridica.cdPessoa;
    this.formGroup.get('cdPessoa').setValue(pessoaJuridica.cdPessoa);
    this.formGroup.markAsDirty();
    
    let cdConcessionario: number;
    
    cdConcessionario =  this.formGroup.get('cdPessoa').value
    return this._concessaoService.getConcessaoEscolar(cdConcessionario).then(concessao => {
      this.formGroup.get('cdConcessao').setValue(concessao.cdConcessao);
    });
  }

  displayFn(concessionario: PessoaJuridica) {
    if (concessionario) {
      return concessionario.pessoa.nmPessoa;
    }
  }

  private _carregar(cdPessoa): Observable<PessoaJuridica>{
    if(!cdPessoa || isNaN(cdPessoa) || this._cdPessoa === cdPessoa){
      return EMPTY;
    }

    return from(this._pessoaService.get(cdPessoa));
  }
  
  private _validarTexo(keyword: string){
    return keyword && keyword.length > 2;
  }
  
  private _buscar(keyword: string){
    return from(this._pessoaJuridicaService.getPermissionario(
      new PessoaSearch({ nmPessoa: keyword, tpConcessao: ConcessaoTipo.ESCOLAR})
    ));
  }

  private _finalizarBusca(resultado: PessoaJuridica[]){
    this.concessionarios = resultado
  }

}
